<div class="row m-0">
  <div class="col-12 p-0">
      <div>
          <form [formGroup]="formGroup" autocomplete="off">
              <kendo-grid [kendoGridBinding]="ReviewList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [skip]="skip" [pageSize]="15" [pageable]="true" id="grvEDMOrgList" (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <ng-template kendoGridToolbarTemplate>
                      <div class="k-grid-toolbar-content d-flex justify-content-end">
                          <div class="pagination-container">
                              <p id="lblShowDetails">Show</p>
                              <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                              </kendo-pager-page-sizes>
                              <span>Items</span>
                          </div>
                          <div class="divider-container d-none d-md-block" id="imgDivider">
                              <span></span>
                          </div>
                          <div class="icons-container">
                              <div class="d-none d-md-flex align-items-md-center">
                                  <div class="icon-wrap">
                                      <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                      <span class="list-icon-name">Filter</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Req No." field="requestNo" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="eip-link" (click)="viewPeerdoc(dataItem)">
                              {{dataItem.old_Ref_Id}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Discipline" field="discipline" width="200">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
                              {{dataItem.discipline}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Created by" field="created_By" width="120">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">
                              {{dataItem.created_By}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Created on" field="created_On" width="100" filter="date" format="{0:dd-MMM-yyyy}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          {{dataItem.created_On | date:'dd-MMM-yyyy'}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Date & Time of Review" width="250">
                    
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          {{dataItem.date | date:'dd-MMM-yyyy'}} {{dataItem.time_From}} - {{dataItem.time_To}}
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" *ngIf="Tabname=='Approval'">
                        <EIPDatePicker formControlName="date" WaterMark="scheduled on" [Min]=todaydate [Value]="editedDate" setId="date" (selectedDate)="updatescheduledOn($event)">
                        </EIPDatePicker>
                        <app-time-picker [lable]="'scheduled From'" [(inputselectedTime)]="sheduleFrom" (selectedTime)="fromTimeSelected($event,'shFrom')"></app-time-picker>
                        <app-time-picker [lable]="'scheduled Upto'" [(inputselectedTime)]="sheduleTo" (selectedTime)="fromTimeSelected($event,'shTo')"></app-time-picker>
                      </ng-template>
                      
                     <!--  <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" *ngIf="Tabname=='Approval'">
                          <EIPDatePicker formControlName="date" WaterMark="scheduled on" [Min]=todaydate [Value]="editedDate" setId="date" (selectedDate)="updatescheduledOn($event)">
                          </EIPDatePicker>
                          <mat-form-field WaterMarkText="scheduled From">
                              <input matInput type="time" (change)="updatescheduledFrom($event)" formControlName="time_from" setId="time_from" [value]="dataItem.time_from">
                          </mat-form-field>

                          <mat-form-field WaterMarkText="scheduled Upto">
                              <input matInput type="time" (change)="updatescheduledUpto($event)" formControlName="time_to" setId="time_to" [value]="dataItem.time_to">
                          </mat-form-field>
                      </ng-template> -->
                  </kendo-grid-column>
                  <kendo-grid-column title="Status" field="request_Status" width="100">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          {{dataItem.request_Status}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column width="100">
                      <ng-template kendoGridHeaderTemplate title="">
                          <span style="margin-left: 1%;"></span>
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <div class="icon-container d-flex" *ngIf="!isinvite(dataItem) && pr_approval">
                              <button kendoGridEditCommand class="k-grid-add-command">
                                  <i class="fa fa-pencil icon-size mr-2" matTooltip="Edit" style="font-size: 20px;" id="" aria-hidden="true"></i>
                              </button>
                              <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                                  <i class="fa fa-save icon-size mr-2" matTooltip="Save" style="font-size: 20px;" id="" aria-hidden="true"></i>
                              </button>
                              <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                                  <i class="fa fa-times-circle icon-size mr-2" matTooltip="Cancel" style="font-size: 20px;" id="" aria-hidden="true"></i>
                              </button>
                              <i class="fa fa-check icon-size mr-2" title="Approve" style="font-size: 20px;" (click)="actionReview(true,dataItem)" *ngIf="!dataItem.is_approve && (dataItem.ds_code != 2)" aria-hidden="true"></i>
                              <!-- <i class="fa fa-ban icon-size mr-2" title="Reject" style="font-size: 15px;" (click)="actionReview(false,dataItem)" *ngIf="!dataItem.is_approve" aria-hidden="true"></i> -->
                          </div>
                          <div class="icon-container d-flex" *ngIf="isinvite(dataItem) && (pr_invite_role || pr_invite_feature)">
                              <i class="fa fa-user-plus icon-size mr-2" title="Invite" style="font-size: 20px;" (click)="openInvitation(dataItem)"></i>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </form>
      </div>
  </div>